import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { SkipNavigation } from './SkipLink';
import { FloatingSupport } from './FloatingSupport';

export function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen min-w-0 bg-[#f5f4ef] relative overflow-x-hidden">
      {/* Floating Support Button */}
      <FloatingSupport />

      {/* Skip navigation for accessibility */}
      <SkipNavigation />

      {/* Sidebar for desktop and mobile */}
      <div id="main-navigation">
        <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      </div>

      {/* Main content area */}
      <div className="min-w-0 lg:pl-72 transition-all duration-300">
        {/* Header */}
        <Header onMenuClick={() => setSidebarOpen(true)} />

        {/* Main content */}
        <main
          id="main-content"
          className="min-w-0 py-4 sm:py-6"
          role="main"
          aria-label="Main content"
        >
          <div className="mx-auto min-w-0 max-w-[1500px] px-4 sm:px-6 lg:px-8">
            {/* Page content */}
            <div className="min-w-0">
              <Outlet />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
